module.exports = __webpack_public_path__ + "static/img/bg.b92e9740.jpg";